<template>
  <button
    :class="[
      variant === 'primary'
        ? 'btn--primary'
        : variant === 'secondary'
        ? 'btn--secondary'
        : variant === 'white'
        ? 'btn--white'
        : variant === 'lightGray'
        ? 'btn--lightGray'
        : '',
      disabled || loading
        ? 'opacity-50 cursor-not-allowed pointer-events-none'
        : '',
      size === 'normal' ? 'btn--normal' : size === 'small' ? 'btn--small' : size === 'average' ? 'btn--average' : '',
    ]"
    @click="$emit('on-click')"
    class="btn"
    :type="type"
    :disabled="loading || disabled"
  >
    <loader :loading="loading" /> <slot></slot>
  </button>
</template>
<script>
import Loader from './Loader.vue';

export default {
  name: 'custom-button',
  components: {
    Loader,
  },
  props: {
    variant: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: false,
      default: 'submit',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String,
      required: false,
      default: 'normal',
    },
  },
};
</script>
